export default __webpack_public_path__ + "static/media/person_logo_icon.162b27f2.svg";